<script setup lang="ts">
import Input from "@/components/Form/Input/Input.vue"
import { ref, computed, watch } from "vue"
import type {
   InputVariant,
   InputState,
   InputSize
} from "@/components/Form/Input/InputEnums"
import Visibility from "./../../../assets/icons/visibility.svg?component"
import VisibilityOff from "./../../../assets/icons/visibility_off.svg?component"

const props = defineProps<{
   modelValue?: string
   id?: string
   variant?: InputVariant
   state?: InputState
   size?: InputSize
   disabled?: boolean
   autocomplete?: string
}>()

const emit = defineEmits<{
   (e: "update:modelValue", value: string): void
   (e: "change", event: Event): void
   (e: "input", event: Event): void
   (e: "blur", event: Event): void
   (e: "focus", event: Event): void
}>()

const value = ref(props.modelValue)
const showPassword = ref(false)

const type = computed(() => {
   return showPassword.value ? "text" : "password"
})

const handleShowPasswordBtnClick = () => {
   showPassword.value = !showPassword.value
}

const handleInputChange = (e: Event) => {
   const target = e.target as HTMLInputElement
   value.value = target.value
   emit("update:modelValue", target.value)
   emit("input", e)
}

watch(
   () => props.modelValue,
   (newValue) => {
      value.value = newValue
   }
)
</script>

<template>
   <div class="password-input">
      <Input
         :id="id"
         v-model="value"
         :type="type"
         :variant="variant"
         :state="state"
         :size="size"
         :disabled="disabled"
         :autocomplete="autocomplete"
         @input="handleInputChange($event)"
         @change="$emit('change', $event)"
         @blur="$emit('blur', $event)"
         @focus="$emit('focus', $event)"
      />
      <span
         class="password-input__toggle-btn"
         @click="handleShowPasswordBtnClick"
      >
         <Visibility v-if="!showPassword" />
         <VisibilityOff v-if="showPassword" />
      </span>
   </div>
</template>
